<template>
    <!--begin::Content wrapper-->
    <div
      dir="rtl"
      class="modal fade forgetpassword-modal"
      id="addDeviceModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              إضافة جهاز
            </h5>
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">
              <i class="fa fa-close"></i> إغلاق
            </button>
          </div>
          <div class="modal-body text-center" style="">
            <div id="reader"  style="width: 500px;min-height: 300px;margin:0 auto;margin-bottom:30px;background-color: #ddd;"></div> <!-- QR Code Reader -->
            <div v-if="qrCodeMessage" class="alert alert-default mt-3">
              Scanned QR Code: {{ qrCodeMessage }}
            </div>
            <div v-if="cameraError" class="alert alert-danger mt-3">
              لم نتمكن من تشغيل الكاميرا. يرجى التحقق من الأذونات.
            </div>
            <button
              type="button"
              class="btn btn-success m-3"
              @click="startQrCodeScanner"  
              v-if="!isScanning" 
            >
              ابدأ مسح QR Code <i class="fa fa-qrcode"></i>
            </button>
            <button
              type="button"
              class="btn btn-danger m-3"
              @click="stopQrCodeScanner"
              v-if="isScanning" 
            >
              أوقف المسح
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              عودة
            </button>
          </div>
        </div>
      </div>
    </div>
    <!--end::Content wrapper-->
  </template>
  
  <script>
  import { Html5Qrcode } from "html5-qrcode";
  import { apiUrl, deviceId } from "@/utils/api"; // Adjust the import path according to your project structure
  import Swal from "sweetalert2";

  export default {
    data() {
      return {
        token: localStorage.getItem("access_token"),
        qrCodeMessage: null,
        qrCodeScanner: null,
        isScanning: false, // Flag to indicate if scanning is active
        cameraError: false, // Flag to indicate camera error
      };
    },
    methods: {
      startQrCodeScanner() {
        this.qrCodeScanner = new Html5Qrcode("reader");
        this.qrCodeScanner.start(
          { facingMode: "environment" }, // Use the rear camera
          {
            fps: 10, // Scanning speed
            qrbox: 250, // QR code scanning box size
          },
          (decodedText) => {
            this.handleQrCode(decodedText,deviceId); // Handle the QR code value
            this.stopQrCodeScanner();
          },
          (errorMessage) => {
            console.warn("QR Code scanning error:", errorMessage);
          }
        ).then(() => {
          this.isScanning = true; // Set scanning flag to true
          this.cameraError = false; // Reset camera error flag
        }).catch((err) => {
          console.error("QR Code scanner failed to start:", err);
          this.cameraError = true; // Set camera error flag
        });
      },
      stopQrCodeScanner() {
        if (this.qrCodeScanner) {
          this.qrCodeScanner.stop().then(() => {
            this.qrCodeScanner.clear();
            this.isScanning = false; // Set scanning flag to false
          }).catch((err) => {
            console.error("Failed to stop QR Code scanner:", err);
          });
        }
      },
      handleQrCode(qrCodeValue,userdeviceId) {
        const [device_id, device_name] = qrCodeValue.split("//");

        if (!device_id || !device_name) {
          // Show alert if validation fails
          alert("رمز QR غير صالح. يرجى المحاولة مرة أخرى.");
          return;
        }
        this.qrCodeMessage = device_name;

        this.addDevice(device_id, device_name,userdeviceId)
      },
      async addDevice(device_id, device_name,userdeviceId) {
        try {
          const data = {
            user_device_id: userdeviceId, // Assuming deviceId is defined elsewhere
            device_id: device_id,
            device_name: device_name,
          };
          const response = await fetch(`${apiUrl}/devices/add-device`, {
            method: "POST",
            headers: {
              Authorization: `Bearer ${this.token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
          });
          if (response.ok) {
            const responseData = await response.json();

            Swal.fire({
            icon: "success",
            title: "تم إضافة الجهاز بنجاح",
            text: "",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
          } else {
            const responseData = await response.json();

            Swal.fire({
            icon: "error",
            title: "حدثت مشكلة ",
            text: responseData.errors,
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });          }
        } catch (error) {
            Swal.fire({
            icon: "error",
            title: "حدثت مشكلة ",
            text: "لم يتم إضافة الجهاز بنجاح",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        } finally {
          this.loading = false;
        }
      },
    },
    beforeDestroy() {
      this.stopQrCodeScanner();
    },
  };
  </script>
  
  <style scoped>
  /* You can add custom styles for the QR code reader here */
  </style>
  